/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
// import TableLayout from './tableLayout';
import { Columns } from './constants';
import { MarketingContext } from '../../../contexts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';
import { fetchCodes } from '../../../hooks/fetch-hooks/get-all-codes/fetch-codes';
import TableLayout from './tableLayout';

function ShortCodeTable() {

    const urlParams = new URLSearchParams(location.search);
    const page = parseInt(urlParams.get('page')) >= 1 ? parseInt(urlParams.get('page')) : 1;
    const pageSizeStr = parseInt(urlParams.get('size')) || 50;

    const [currentPage, setCurrentPage] = useState(page);
    const [tableData, setTableData] = useState([]);
    const [total, setTotal] = useState(0);
    // eslint-disable-next-line no-unused-vars
    const [pageSize, setPageSize] = useState(pageSizeStr);

    const { data: codesData, refetch } = fetchCodes(currentPage, pageSize, '');

    useEffect(() => {
        const updateUrl = () => {
            const url = new URL(location);
            url.searchParams.set('page', currentPage);
            url.searchParams.set('size', pageSize);
            history.pushState({}, '', url);
        };
        updateUrl();
        refetch();
    }, [currentPage, history, location]);

    useEffect(() => {
        if (codesData?.data?.data) {
            setTableData(codesData.data.data.rows);
            setTotal(codesData.data.data.count);
        }
    }, [codesData]);



    return (
        <div className="h-full overflow-y-scroll bg-gray-50">
            <button
                onClick={() => {
                    if (currentPage !== 1) {
                        setCurrentPage(1)
                    } else {
                        refetch();
                    }
                }}
                className='flex gap-2 items-center justify-center bg-[#00A48B] py-[1rem] px-[1.5rem] rounded-lg my-[0.5rem]'
            >
                <FontAwesomeIcon icon={faRefresh} color='#fff' />
                <span className='text-[1.2rem] font-medium text-[#fff]' >Refresh</span>
            </button>
            <MarketingContext.Provider value={{ data: tableData, columns: Columns, refetch }}>
                {tableData.length > 0 && <TableLayout />}
            </MarketingContext.Provider>
            <div className="btn_div">
                <button disabled={currentPage <= 1} onClick={() => setCurrentPage(currentPage - 1)} className="previous">Previous</button>
                <span className="pageindex">Page {currentPage} of {Math.ceil(total / pageSize)}</span>
                <button disabled={currentPage >= Math.ceil(total / pageSize)} onClick={() => setCurrentPage(currentPage + 1)} className="next">Next</button>
            </div>
        </div>
    );
}

export default ShortCodeTable;
